module.exports = __webpack_public_path__ + "img/icon_down-c4702c4e.svg";